export * from './StartegyDetails';
